import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Link, useParams } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto'; // This is required for the latest version of chart.js

const ViewEachPostPerformance = () => {
    const [performanceData, setPerformanceData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { LinkdinPostId } = useParams();
    const AccessToken = localStorage.getItem("AccessToken");

    useEffect(() => {
        const fetchPerformanceData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getindividualpostperformance`, {
                    params: {
                        LinkdinPostId: LinkdinPostId,
                        AccessToken: AccessToken,
                    },
                });

                // Set the performance data for rendering
                setPerformanceData(response.data);
                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch performance data:', err.message);
                setError('Failed to fetch performance data');
                setLoading(false);
            }
        };
        fetchPerformanceData();
    }, [LinkdinPostId, AccessToken]);

    // Ensure performance data is available before rendering the chart
    const data = performanceData ? {
        labels: ['Total Likes', 'Aggregated Likes', 'Total Comments'],
        datasets: [
            {
                label: 'Post Performance',
                data: [
                    performanceData.likesSummary.totalLikes,
                    performanceData.likesSummary.aggregatedTotalLikes,
                    performanceData.commentsSummary.aggregatedTotalComments
                ],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)'
                ],
                borderWidth: 1,
            },
        ],
    } : null;

    return (
        <SideNavbar>
            <div className='container'>
                <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                    <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
                        <Link to="/viewallpendingposts">
                            <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>
                                <i className="fa fa-arrow-left" style={{ marginRight: '30px' }} aria-hidden="true"></i>
                                View Post Performance
                            </h5>
                        </Link>
                    </div>
                    <hr />
                    {loading ? (
                        <div className='spinner'></div>
                    ) : (
                        performanceData ? (
                            <div>
                                <Bar data={data} options={{ responsive: true, maintainAspectRatio: false }} />
                            </div>
                        ) : (
                            <p>No performance data available</p>
                        )
                    )}
                    {error && <p className='text-danger'>{error}</p>}
                </div>
            </div>
        </SideNavbar>
    );
};

export default ViewEachPostPerformance;
